import { render, staticRenderFns } from "./ContactsTable.vue?vue&type=template&id=40e81638&"
import script from "./ContactsTable.vue?vue&type=script&lang=ts&"
export * from "./ContactsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GFaIcon from 'shared/global/components/FaIcon.vue'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {GFaIcon,VDataTable,VIcon,VTooltip})
